import React from "react";
import { Button, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

export default function DeleteProduct({
  setModal,
  currentComponent,
  deleteComponent,
  itemType,
  modalTitle,
}) 
{
  console.log(currentComponent,"cureent")
  return (
    <>
      <ModalHeader toggle={() => setModal((state) => !state)}>
         Delete Product {modalTitle}
      </ModalHeader>
      <ModalBody>
        Permanently delete {itemType} <strong>{currentComponent?.name}</strong>?
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={() => {
            setModal((state) => !state);
            deleteComponent();
          }}
        >
          Yes
        </Button>
        <Button color="secondary" onClick={() => setModal((state) => !state)}>
          Cancel
        </Button>
      </ModalFooter>
    </>
  );
}
